import React,{ useState, useEffect, useRef } from 'react';
import { Col, Row, Collapse } from 'antd';
import { CloseOutlined  } from '@ant-design/icons';

import BaseButton from '../../components/BaseButton/BaseButton'
import CardDom from '../CardDom/CardDom';

import './Questions.less'


const Questions = ({questionsData}) =>{
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(()=>{
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
 
    // 添加事件监听器
    window.addEventListener('resize', handleResize);
 
    // 清理函数，组件卸载时移除事件监听器
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  },[])

  if(width > 770){
    return (
      <div className="questions-box">
        <div style={{width: '100%',maxWidth: 1440, margin: '0 auto',display: 'flex',justifyContent: 'space-between'}}>
          <div className="questions-left">
            <div style={{fontSize:'clamp(32px, calc(27.07px + 1.31vw), 46px)', marginBottom: 20}}>常见问题</div>
            <div style={{fontSize:'clamp(16px, calc(15.65px + 0.09vw), 17px)',color:'rgba(0,0,0,0.54)'}}>
              还有其他问题吗？访问我们的帮助中心
              {/* Have more questions? Visit our <span style={{color: '#272724', borderBottom:'1px solid #272724'}}>Help Center</span> or inquire at <span style={{color: '#272724', borderBottom:'1px solid #272724'}}>care@timeline.com</span> */}
            </div>
          </div>
          <div className="questions-right">
            <Collapse items={questionsData} bordered={false} defaultActiveKey={['1']} />
          </div>
        </div>
      </div>
    )
  }else{
    return (
      <div className="questions-box-phone">
        <div style={{width: '100%',maxWidth: 1440, margin: '0 auto'}}>
          <div className="questions-left">
            <div style={{fontSize:'clamp(32px, calc(27.07px + 1.31vw), 46px)', marginBottom: 20}}>常见问题</div>
            <div style={{fontSize:'clamp(16px, calc(15.65px + 0.09vw), 17px)',color:'rgba(0,0,0,0.54)'}}>
            还有其他问题吗？访问我们的帮助中心
            </div>
          </div>
          <div className="questions-right">
            <Collapse items={questionsData} bordered={false} defaultActiveKey={['1']} />
          </div>
        </div>
      </div>
    )
  }
}

export default Questions